export default {
  id: "insights",
  name: "Insights",
  shortName: "Insights",
  description: "Analytics & reporting across your channels",
  icon: "barChart",
  color: "#2563EB",
  roles: ["super_admin", "admin", "corporate", "marketing_agency"],
  css: "styles/apps/insights.css?v=14",
  nav: [
    { id: "overview", label: "Overview" },
    { id: "growth", label: "Growth" },
    { id: "audience", label: "Audience" },
    { id: "content", label: "Content" },
    { id: "connections", label: "Connections" },
  ],
  defaultView: "overview",
};
